import { useState } from "react";
import { ImagePlus, Loader2, X } from "lucide-react";
import api, { fileUrl } from "@/lib/api";
import { toast } from "sonner";

export default function MultiImageUpload({ value = [], onChange, testId = "gallery" }) {
  const [loading, setLoading] = useState(false);
  const list = value || [];

  const add = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange([...list, data.url]);
    } catch { toast.error("Upload failed"); }
    finally { setLoading(false); }
  };

  const remove = (i) => onChange(list.filter((_, idx) => idx !== i));

  return (
    <div className="flex flex-wrap gap-2" data-testid={testId}>
      {list.map((u, i) => (
        <div key={i} className="relative w-20 h-20 rounded-md overflow-hidden border border-border group">
          <img src={fileUrl(u)} alt="" className="w-full h-full object-cover" />
          <button type="button" onClick={() => remove(i)} data-testid={`${testId}-remove-${i}`} className="absolute top-0.5 right-0.5 bg-black/70 text-white rounded-full p-1">
            <X className="w-3 h-3" />
          </button>
        </div>
      ))}
      <label className="w-20 h-20 flex flex-col items-center justify-center border border-dashed border-border rounded-md cursor-pointer hover:bg-secondary" data-testid={`${testId}-add`}>
        {loading ? <Loader2 className="w-4 h-4 animate-spin text-accent" /> : <ImagePlus className="w-5 h-5 text-muted-foreground" />}
        <input type="file" accept="image/*" className="hidden" onChange={add} />
      </label>
    </div>
  );
}
